module.exports = __webpack_public_path__ + "img/digitOci.da6bdcea.png";